import { useMutation } from '@tanstack/react-query';
import axiosClient from 'api/config/axios';
import { adaptArbitrationPayment, adaptDispute } from 'api/escrow/adapters';
import { ArbitrationPayment, Dispute } from 'api/escrow/types';

type Params = {
  disputeId: string;
  driver?: string;
  paymentMethod?: string;
};

type FundInspectionCostResult = {
  dispute: Dispute;
  payment: ArbitrationPayment | null;
};

async function fundInspectionCost(params: Params): Promise<FundInspectionCostResult> {
  const body: { driver?: string; payment_method?: string } = {};
  if (params.driver !== undefined) body.driver = params.driver;
  if (params.paymentMethod !== undefined) body.payment_method = params.paymentMethod;

  const result = await axiosClient.mutate.post(`/api/v1/escrow/cases/${params.disputeId}/fund-inspection-cost`, body);
  return {
    dispute: adaptDispute(result.data.dispute),
    payment: result.data.payment ? adaptArbitrationPayment(result.data.payment) : null,
  };
}

const mutationKey = ['escrow', 'fund-inspection-cost'] as const;

export function useFundInspectionCostMutation() {
  return useMutation({
    mutationKey,
    mutationFn: fundInspectionCost,
    // Error handling is owned by ArbitrationFundingSection.tsx, which differentiates 409 / 422 /
    // generic errors and applies the anti-loop rule. Adding a mutation-level onError snackbar
    // would surface duplicate notifications for the same failure.
  });
}
